import { Controller } from "@hotwired/stimulus"

// Una chip cliccata riempie la textarea della chat e invia il form.
export default class extends Controller {
  send(event) {
    const text = event.params.text
    const container = document.getElementById("proposal_chat_form")
    const input = container?.querySelector("textarea")
    const form = input?.closest("form")
    if (!input || !form) return
    input.value = text
    form.requestSubmit()
  }
}
